import {
    GiAtom,
    GiChemicalDrop,
    GiCrystalGrowth,
    GiCutLemon, GiDna2, GiFizzingFlask,
    GiMeltingIceCube,
    GiMineExplosion,
    GiMolecule, GiPrism, GiWaterBottle
} from "react-icons/gi";
import {SiElectron, SiGrapheneos, SiMoleculer} from "react-icons/si";
import {MdOutlineWaterDrop} from "react-icons/md";
import {IoEarth} from "react-icons/io5";
import {FaBalanceScale, FaBookOpen} from "react-icons/fa";
import React from "react";
import {PiFlaskFill} from "react-icons/pi";

export function convertIcon(iconName, iconSize) {
    switch (iconName) {
        case "crystal":
            return (<GiCrystalGrowth size={iconSize} />);
        case "molecule":
            return (<SiMoleculer size={iconSize} />);
        case "water":
            return (<MdOutlineWaterDrop size={iconSize} />);
        case "vile":
            return (<GiChemicalDrop size={iconSize} />);
        case "explosion":
            return (<GiMineExplosion size={iconSize}/>);
        case "lemon":
            return (<GiCutLemon size={iconSize}/>);
        case "ice":
            return (<GiMeltingIceCube size={iconSize}/>);
        case "earth":
            return (<IoEarth size={iconSize}/>);
        case "atom":
            return (<GiAtom size={iconSize}/>)
        case "binding":
            return (<GiMolecule size={iconSize}/>);
        case "flask":
            return (<PiFlaskFill size={iconSize}/>);
        case "prism":
            return (<GiPrism size={iconSize}/>);
        case "balance":
            return (<FaBalanceScale size={iconSize}/>);
        case "benzen":
            return (<SiGrapheneos size={iconSize}/>);
        case "atomic_orbit":
            return (<SiElectron size={iconSize}/>);
        case "synthesize":
            return (<GiFizzingFlask size={iconSize}/>);
        case "dna":
            return (<GiDna2 size={iconSize}/>);
        case "water_bottle":
            return (<GiWaterBottle size={iconSize}/>);
        default:
        case "default":
            return (<FaBookOpen size={iconSize} />);
    }
}